import { Component } from '@stencil/core';

@Component({
  tag: 'uui-default-theme-v2_0',
  shadow: true,
  styleUrl: `../../global/default-theme-2.0.scss`
})
export class UuiDefaultThemeProviderV2_0 {}
